import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { EpicsCount } from './EpicsCount';

export class EpicsFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [EpicsCount];
  }

  get title() {
    return terminology('Epics');
  }
}
